export default "__VITE_ASSET__kOfMhHTM__"